import EmailTemplateEdit from './EmailTemplateEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal'
import { columnsheadId } from '../../universal/columnshead';

//组件 
const WebComponent = (props: any) => {

    /** api服务id */
    const apiId = 'emailTemplate';

    //表头
    const columnsHead = [
        {
            title: '名称',
            dataIndex: 'templateName'
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '邮件模版',
        apiId,
        columns,
        editOptions: {
            Editor: EmailTemplateEdit
        },
        serviceId: 'business'
    };

    return (
        <WebUniversal {...extendProps} />
    )
}

export default WebComponent;
